var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name"},[_c('div',{staticClass:"gignac-andre-pierre valign-text-middle avenirnextltpro-bold-white-16px"},[_vm._v(_vm._s(_vm.playerName))])])}
var staticRenderFns = []

export { render, staticRenderFns }